import React, { useEffect } from 'react';
import { ChapterStats } from '../types';
import { useSoundEffects } from '../context/SoundEffectsContext';
import './ChapterSummaryPage.css';

interface ChapterSummaryPageProps {
  stats: ChapterStats;
}

const ChapterSummaryPage: React.FC<ChapterSummaryPageProps> = ({ stats }) => {
  const { playSound } = useSoundEffects();

  useEffect(() => {
    playSound('chapter_complete');
  }, [playSound]);
  // Format cards played for display
  const formatCardList = () => {
    const entries = Object.entries(stats.cards_played_by_name);
    if (entries.length === 0) return 'None';

    return entries.map(([name, count]) => {
      return count > 1 ? `${name} (${count}x)` : name;
    }).join(', ');
  };

  // Format card types for display
  const formatCardTypes = () => {
    const entries = Object.entries(stats.cards_played_by_type);
    if (entries.length === 0) return 'None';

    return entries.map(([type, count]) => {
      const typeLabel = type.charAt(0).toUpperCase() + type.slice(1);
      return `${typeLabel}: ${count}`;
    }).join(' | ');
  };

  return (
    <div className="chapter-summary-content">
      <div className="lab-report">
        <div className="lab-report-header">
          <div className="lab-report-title">
            <span className="title-icon">🧪</span>
            <span>Lab Report</span>
            <span className="title-icon">🧬</span>
          </div>
        </div>

        <div className="lab-report-body">
          <div className="experiment-log">
            <h4 className="log-header">EXPERIMENT LOG: Chapter Complete</h4>

            <div className="report-section">
              <div className="report-line">
                <span className="report-label">Subject:</span>
                <span className="report-value">Percy (Feline Form)</span>
              </div>
            </div>

            <div className="report-section">
              <div className="report-line">
                <span className="report-label">Puzzle:</span>
                <span className="report-value">{stats.puzzle_name}</span>
              </div>
            </div>

            <div className="report-section">
              <div className="report-line">
                <span className="report-label">Turns Taken:</span>
                <span className="report-value">{stats.turns_taken}</span>
              </div>
            </div>

            <div className="report-section">
              <div className="report-line">
                <span className="report-label">Cards Utilized:</span>
                <span className="report-value cards-list">{formatCardList()}</span>
              </div>
            </div>

            <div className="report-section">
              <div className="report-line">
                <span className="report-label">Card Types:</span>
                <span className="report-value">{formatCardTypes()}</span>
              </div>
            </div>

            <div className="experiment-footer">
              <div className="status-stamp">EXPERIMENT SUCCESSFUL</div>
              <div className="scientist-note">
                "Excellent progress! The subject continues to exceed expectations."
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterSummaryPage;